import React from 'react';
import siteContent from '../data/siteContent';
import './Footer.css';

export default function Footer() {
  const { company, footer } = siteContent;
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <span>© {year} {footer.copyrightEntity}. All rights reserved.</span>
      <span>
        <a href={`mailto:${company.email}`}>{company.email}</a>
      </span>
    </footer>
  );
}
